/**
 * Справочник VLAN — общий для раздела «Порты» и выгрузки.
 * Загружается после входа и перечитывается по событию сервера, когда
 * кто-то правит справочник.
 */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';
import { toVlanMap } from '../../domain/vlans';

export const loadVlans = createAsyncThunk('vlans/load', async () => {
  const data = await api.get('/api/vlans');
  return data.vlans;
});

const vlansSlice = createSlice({
  name: 'vlans',
  initialState: { list: [], map: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadVlans.fulfilled, (state, action) => {
      state.list = action.payload;
      state.map = toVlanMap(action.payload);
    });
  },
});

export const selectVlanList = (state) => state.vlans.list;
export const selectVlanMap = (state) => state.vlans.map;

export default vlansSlice.reducer;
